<template>
  <div class="footer">
    © 2022 Zoom Video Communications, Inc. All rights reserved.
  </div>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style lang="scss" scoped>
.footer {
  position: fixed;
  box-sizing: border-box;
  text-align: center;
  color: #666;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  width: 100%;
  left: 0;
  bottom: 0;
  background: transparent;
  z-index: 1002;
}
</style>
